/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

function processLawson(addTo, values) {
  const { units, useDining } = addTo.app
  const conversions = addTo.lawsonConversions
  const colors = addTo.sumerian.colors
  values.forEach(data => {
    const { location, config, season, rating, dataType } = data

    addTo.locations[location].ratings[config] =
      addTo.locations[location].ratings[config] || {}
    const loc = addTo.locations[location].ratings[config]
    loc[season] = loc[season] || {}

    loc[season][dataType] = rating
    loc[season][`${dataType}Rating`] = convertRating(
      rating,
      conversions[dataType]
    )

    loc[season][`${dataType}Color`] = colors[loc[season][`${dataType}Rating`]]
  })

  return addTo
}

export function convertRating(rating, ratings) {
  return ratings.find(({ name, threshold }) => threshold >= rating).name
}

export default processLawson
